import React, { Component } from "react";
import { If } from "react-extras";
import "./loading_button.scss";
import loadingSpinner from "../../../icons/loading-spinner-white.svg";

class LoadingButton extends Component {
  render() {
    let { className, Button, isLoading, ...props } = this.props;
    Button = Button || "button";
    return (
      <Button className={className} {...props} disabled={isLoading || props.disabled}>
        <If condition={!isLoading}>{this.props.children}</If>
        <If condition={!!isLoading}>
          <div className="loading-spinner-wrapper">
            <img src={loadingSpinner} alt="loading" className="loading-button__spinner" />
            <If condition={!!this.props.progress && this.props.progress > 0}>
              {" (" + Math.round(this.props.progress * 95) + "%)"}
            </If>
          </div>
        </If>
      </Button>
    );
  }
}

export default LoadingButton;
